import { DestroyRef, Injectable } from '@angular/core';
import { Hotkey, HotkeysService } from 'angular2-hotkeys';

/** needs to be provided at component level */
@Injectable()
export class ComponentHotkeyService {

  constructor(
    private hotkeysService: HotkeysService,
    private destroyRef: DestroyRef,
  ) {
  }

  /** Adds a hotkey that is automatically unregistered when the destroyRef is triggered */
  public add(combo: string | string[], callBack: () => void, options?: { allowRepeat?: boolean; allowIn?: string[]; },): void {
    const hotKey = this.hotkeysService.add(new Hotkey(combo, (event) => {
        if (event.isComposing || (event.repeat && !options?.allowRepeat)) {
          return true;
        }

        callBack();
        return false;
      },
      options?.allowIn));

    this.destroyRef.onDestroy(() => {
      this.hotkeysService.remove(hotKey);
    });
  }
}
